import React, { useEffect } from 'react';
import SEO from '../SEO/SEO';
import About from '../About/About';

function AboutPage() {
  useEffect(() => {
    // Initialize animations when component mounts
  }, []);

  return (
    <div className="app">
      <SEO
  title="About Boldly English"
  description="Learn more about Boldly English, our mission, and how we make English learning simple, interactive, and engaging."
canonical="https://boldlyenglish.com/about"
/>
      <About />
    </div>
  );
}

export default AboutPage;